module.exports = __webpack_public_path__ + "img/APPARAT POPP.a279e9c5.png";